
import { defineComponent } from 'vue';
import InputText from 'primevue/inputtext';

export default defineComponent({
  name: "StringPicker",
  components: {InputText},
  data () {
      return {
        error: false as boolean,
        selected: this.value
      }
    },
  props: {
    name: {type: String, required: true},
    placeholder: {type: String, required: true},
    value: { type: String, required: true }
  },
  watch: {
    selected() {
      this.$emit('select', {key: this.name, value: this.selected })
    },
  }
})
